/**
 * Route tree owned by the tickets module. The app router composes this tree
 * alongside other modules' trees in `app/router/routes.ts` — it never
 * defines tickets' child routes itself.
 */
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import { rootRoute } from '../../app/router/rootRoute';
import { ticketsDashboardSchema } from './schemas/ticketsDashboard.schema';

const TicketsDashboard = lazy(() =>
  import('./pages/TicketsDashboard').then((module) => ({
    default: module.TicketsDashboard,
  })),
);

const ticketsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'tickets',
  validateSearch: ticketsDashboardSchema,
  component: TicketsDashboard,
});

export const ticketsRouteTree = ticketsIndexRoute;
